import { ShopGroupsPage } from 'features/shop-groups';

export const AdminShopGroupsPage: React.FC = () => <ShopGroupsPage />;
